import React from 'react';
import { COMPANY } from '../../siteData';
import {
  Section,
  SectionInner,
  SectionHeader,
  Eyebrow,
  SectionTitle,
} from '../ui/Section';
import {
  AboutBody,
  AboutP,
  FactsRow,
  Fact,
  FactLabel,
  FactValue,
} from './AboutElements';

const About = () => {
  return (
    <Section id='about'>
      <SectionInner>
        <SectionHeader>
          <Eyebrow>About</Eyebrow>
          <SectionTitle>About {COMPANY.legalName}</SectionTitle>
        </SectionHeader>
        <AboutBody>
          <AboutP>
            {COMPANY.legalName} is a technology company based in {COMPANY.city},{' '}
            {COMPANY.state}. We operate as both a software consultancy and a
            product studio — partnering with clients to build custom software,
            and developing and operating our own products.
          </AboutP>
          <AboutP>
            Our portfolio includes Repatch, an AI phone receptionist for
            home-service businesses. Repatch is a product of {COMPANY.legalName}.
            As the operating entity, {COMPANY.legalName} is responsible for the
            products we run and the messaging programs they use to communicate
            with customers.
          </AboutP>
        </AboutBody>
        <FactsRow>
          <Fact>
            <FactLabel>Headquarters</FactLabel>
            <FactValue>
              {COMPANY.city}, {COMPANY.state}
            </FactValue>
          </Fact>
          <Fact>
            <FactLabel>Entity</FactLabel>
            <FactValue>Limited Liability Company</FactValue>
          </Fact>
          <Fact>
            <FactLabel>Focus</FactLabel>
            <FactValue>Software &amp; AI</FactValue>
          </Fact>
        </FactsRow>
      </SectionInner>
    </Section>
  );
};

export default About;
